import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core'
import { FilterOption, Search } from '../search-types'

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit {
    @ViewChild('dropdown') dropdown!: ElementRef;

    @Input() filters: FilterOption[] = []

    @Input() useActionFooter = false
    @Input() useActionSide = false
    @Input() width = 600
    @Input() isFetchingData = false

    @Output() onSearch = new EventEmitter<Search<string, any>>()
    @Output() onClear = new EventEmitter()

    isOpen = false

    currentFilter: FilterOption | null = null
    currentSearchValue: string | null = null
    currentOptionSelected: any

    constructor() { }

    ngOnInit(): void {
        this.setDefaultFilter()
    }

    // Fecha o dropdown ao clicar fora
    @HostListener('document:click', ['$event'])
    onOutClickFilterBox(event: Event) {
        if (this.isOpen && this.dropdown && !this.dropdown.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    }

    private setDefaultFilter() {
        const defaultOption = this.filters.find(option => option.isDefault)

        if (defaultOption) {
            this.currentFilter = defaultOption
        }
    }

    public handleToggleFilters() {
        this.isOpen = !this.isOpen
    }

    public handleSearch() {
        this.onSearch.emit({ type: this.currentFilter?.type, value: this.currentSearchValue! })
    }

    public handleClear() {
        this.currentSearchValue = null
        this.currentOptionSelected = null
        this.onClear.emit()
    }

    public onOptionChange(option: FilterOption) {
        this.currentFilter = option
        this.currentSearchValue = null
        this.handleToggleFilters()
    }

    public getSearchPlaceholder() {
        return this.currentFilter?.placeholder
    }

    public onSelectSearchableOption(option: any) {
        this.currentSearchValue = option.id
        this.currentOptionSelected = option
    }
}
